'use strict'
import React from 'react'
import {
  makeStyles,
  Box,
  Button,
  Select,
  MenuItem,
  Typography,
  Chip,
  Tabs,
  Tab,
  IconButton
} from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import AddIcon from '@material-ui/icons/Add'
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline'
import PublishIcon from '@material-ui/icons/Publish'
import RefreshIcon from '@material-ui/icons/Refresh'

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2, 2, 0, 2)
  },
  topRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    flexWrap: 'wrap',
    marginBottom: theme.spacing(1)
  },
  title: {
    fontWeight: 600,
    marginRight: theme.spacing(1)
  },
  scenarioSelect: {
    minWidth: 220
  },
  statusRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flexWrap: 'wrap',
    marginBottom: theme.spacing(1)
  },
  tabs: {
    borderBottom: `1px solid ${theme.palette.divider}`
  }
}))

const TAB_LABELS = ['Properties', 'Compare', 'Anchors', 'Map', 'Routes']

export default function WorkbenchHeader ({
  scenarios,
  selectedScenarioId,
  selectedScenario,
  onScenarioChange,
  onCreateNew,
  onDelete,
  onPublish,
  onRefresh,
  onBack,
  currentTab,
  onTabChange,
  publishDisabled,
  propertyCount,
  vipCount,
  lockedCount,
  unassignedCount,
  anchorCount
}) {
  const classes = useStyles()

  const statusLabel = selectedScenario
    ? selectedScenario.status.toUpperCase()
    : ''
  const overrideCount = selectedScenario?.assignmentCount
  const isStale = selectedScenario?.isStaleAtCreation

  return (
    <div className={classes.root}>
      <div className={classes.topRow}>
        <Button
          variant="outlined"
          size="small"
          startIcon={<ArrowBackIcon />}
          onClick={onBack}
        >
          Back
        </Button>
        <Typography variant="h6" className={classes.title}>Territory Workbench</Typography>
        <Select
          value={selectedScenarioId || ''}
          onChange={(e) => onScenarioChange(e.target.value)}
          variant="outlined"
          size="small"
          displayEmpty
          className={classes.scenarioSelect}
        >
          <MenuItem value="">Live (no scenario)</MenuItem>
          {scenarios.map(item => (
            <MenuItem key={item._id} value={item._id}>
              {item.name} ({item.status}{item.isStaleAtCreation ? ', stale' : ''})
            </MenuItem>
          ))}
        </Select>
        <Button
          variant="outlined"
          size="small"
          startIcon={<AddIcon />}
          onClick={onCreateNew}
        >
          New Draft
        </Button>
        {selectedScenarioId && onDelete && (
          <Button
            variant="outlined"
            size="small"
            startIcon={<DeleteOutlineIcon />}
            onClick={onDelete}
            style={{ color: '#f44336', borderColor: '#f44336' }}
          >
            Delete
          </Button>
        )}
        <Button
          variant="contained"
          color="secondary"
          size="small"
          startIcon={<PublishIcon />}
          disabled={publishDisabled}
          onClick={onPublish}
        >
          Publish
        </Button>
        <IconButton size="small" onClick={onRefresh}>
          <RefreshIcon />
        </IconButton>
      </div>

      <div className={classes.statusRow}>
        {selectedScenario ? (
          <>
            <Chip size="small" label={statusLabel} color={selectedScenario.status === 'draft' ? 'primary' : 'default'} />
            {overrideCount != null && (
              <Chip size="small" variant="outlined" label={`${overrideCount} overrides`} />
            )}
          </>
        ) : (
          <Chip size="small" label="LIVE" style={{ backgroundColor: '#4caf50', color: '#fff', fontWeight: 700 }} />
        )}
        {propertyCount > 0 && (
          <Chip size="small" variant="outlined" label={`${propertyCount} properties`} />
        )}
        {vipCount > 0 && (
          <Chip size="small" variant="outlined" label={`${vipCount} VIP`} />
        )}
        {lockedCount > 0 && (
          <Chip size="small" variant="outlined" label={`${lockedCount} locked`} />
        )}
        {anchorCount > 0 && (
          <Chip size="small" variant="outlined" label={`${anchorCount} anchors`} />
        )}
        {unassignedCount > 0 && (
          <Chip size="small" variant="outlined" label={`${unassignedCount} unassigned`} style={{ color: '#f44336', borderColor: '#f44336' }} />
        )}
        {isStale && (
          <Chip size="small" color="secondary" label="Stale sync" />
        )}
      </div>

      <Tabs
        className={classes.tabs}
        value={currentTab}
        onChange={(_, val) => onTabChange(val)}
        indicatorColor="primary"
        textColor="primary"
      >
        {TAB_LABELS.map(label => (
          <Tab key={label} label={label} value={label.toLowerCase()} />
        ))}
      </Tabs>
    </div>
  )
}
